import React from "react";

const CostsCard = ({ cost }) => {
  // Calculate Fixed Costs total
  const fixedCostsTotal = (
    parseFloat(cost.printingCost || 0) +
    parseFloat(cost.listsCost || 0) +
    parseFloat(cost.lettershopCost || 0) +
    parseFloat(cost.postageCost || 0) +
    parseFloat(cost.dataProcessingCost || 0) +
    parseFloat(cost.miscFee || 0)
  ).toFixed(2);

  // Calculate Variable Costs total
  const variableCostsTotal = (
    parseFloat(cost.merchantFee || 0) +
    parseFloat(cost.productCost || 0) +
    parseFloat(cost.callCenterCost || 0) +
    parseFloat(cost.shippingCost || 0) +
    parseFloat(cost.fulfillmentCost || 0) +
    parseFloat(cost.royalty || 0) +
    parseFloat(cost.refundCost || 0)
  ).toFixed(2);

  // Calculate Total Cost
  const totalCost = (parseFloat(fixedCostsTotal) + parseFloat(variableCostsTotal)).toFixed(2);

  return (
    <div className="card">
      <div className="card-body p-0">
        <table className="table table-bordered table-sm mb-0">
          <thead>
            <tr>
              <th className="bg-light text-center py-1" style={{ width: '50%' }}>Fixed Cost</th>
              <th className="bg-light text-center py-1" style={{ width: '50%' }}>Variable Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Printing</span>
                  <span>${cost.printingCost || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Merchant Fee</span>
                  <span>${cost.merchantFee || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Lists Cost</span>
                  <span>${cost.listsCost || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1  small">
                  <span>Product Cost</span>
                  <span>${cost.productCost || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Lettershop</span>
                  <span>${cost.lettershopCost || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Call Center Cost</span>
                  <span>${cost.callCenterCost || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Postage</span>
                  <span>${cost.postageCost || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Shipping Cost</span>
                  <span>${cost.shippingCost || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Data Processing</span>
                  <span>${cost.dataProcessingCost || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Fulfillment Cost</span>
                  <span>${cost.fulfillmentCost || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Misc Fee</span>
                  <span>${cost.miscFee || '0.00'}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Royalty</span>
                  <span>${cost.royalty || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <div className="d-flex justify-content-between py-1 small">
                  <span>Refund Cost</span>
                  <span>${cost.refundCost || '0.00'}</span>
                </div>
              </td>
            </tr>
            <tr className="bg-light">
              <td>
                <div className="d-flex justify-content-between py-1 font-weight-bold">
                  <span>Fixed Cost Total</span>
                  <span>${fixedCostsTotal}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between py-1 font-weight-bold">
                  <span>Variable Cost Total</span>
                  <span>${variableCostsTotal}</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr className="bg-secondary text-white">
              <td colSpan="2">
                <div className="d-flex justify-content-between py-1 font-weight-bold">
                  <span>Total Cost</span>
                  <span>${totalCost}</span>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default CostsCard;
